export default __webpack_public_path__ + "static/media/b-2.912a238c.png";